// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2638":"e058a96d","2793":"5bcd866d","5503":"cf30f18c","8442":"5bcd866d","9780":"5bcd866d"}[chunkId] + ".chunk.css";
};